import template from "../editor/template_data_shopee_ads_1528189";
import * as childTemplate from "../editor/template_data";
import cc from "../editor/cc_data";
import {IBannerTemplate} from "./types";

export const defaultActive: IBannerTemplate = {
    id: "new",
    name: "new template",
    template: "",
    designBannerVariablesId: "",
    feedBannerVariablesId: "",
    sassFolderId: "scss",
    htmlFolderId: "html",
    screenShot: "",
    customCode: cc,
    created: {},
    updated: {},
};


export const defaultMasterActive: IBannerTemplate = {
    id: "default_master",
    name: "default master",
    isMaster: true,
    template: "",
    designBannerVariablesId: "",
    feedBannerVariablesId: "",
    sassFolderId: "scss",
    htmlFolderId: "html",
    screenShot: "",
    customCode: cc,
    created: {},
    updated: {},
};

export const defaultChildActive: IBannerTemplate = {
    id: "default_child",
    name: "default child",
    parentId: "default_master",
    template: "",
    designBannerVariablesId: "",
    feedBannerVariablesId: "",
    sassFolderId: "scss",
    htmlFolderId: "html",
    screenShot: "",
    customCode: cc,
    created: {},
    updated: {},
};
